import styled from 'styled-components';

export const MissingValue = styled.span`
  color: var(--color-text-muted);
  font-size: 14px;
`;
